import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import RunIcon from 'material-ui/svg-icons/av/play-arrow';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment-ind';
import ProgrammeIcon from 'material-ui/svg-icons/action/assignment';

import TrainerIcon from 'material-ui/svg-icons/editor/title';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';

import ScheduleIcon from 'material-ui/svg-icons/action/schedule';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import { statusColours } from '../../constants/ColourConstants';
import AssignmentActions from '../../actions/AssignmentActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};
const getActions = ({id, name, sysStatus}, {assignDialogAction}) => [
    {
        action: () => assignDialogAction(id),
        label: 'Run',
        icon: <RunIcon/>,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/assignment/${id}/edit`,
        label: 'Edit',
        icon: <EditIcon/>,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete',
        deleteAction: AssignmentActions.delete,
        message: (<span>Delete assignment  "{name}" ? </span>),
        condition: {
            show: sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];

const AssignmentListItem = ({data, actions}) => {

    const infoLink = `/dashboard/assignment/${data.id}`;


    let listItemProps = {
        key: data.id,
        style: style.listItem
    };


    listItemProps.primaryText = (
        <Link to={infoLink} className="primaryText">
            {data.name}
        </Link>
    );

    let iconGroup = [];

    if (!!data.complianceName) {
        iconGroup.push(<ComplianceIcon className="icon-small" color={statusColours.medium} key="compliance" />);
    }

    if (!!data.programmeName) {
        iconGroup.push(<ProgrammeIcon className="icon-small" color={statusColours.medium} key="programme" />);
    }

    if (data.type === 'trainer') {
        iconGroup.push(<TrainerIcon className="icon-small" color={statusColours.medium} key="trainer" />);
    }

    if (data.auto) {
        iconGroup.push(<ScheduleIcon className="icon-small" color={statusColours.medium} key="scheduled" title={data.schedule} />);
    }

    if (data.requirement === 1) {
        iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
    } else {
        iconGroup.push(<SpotIcon className="icon-small" color={statusColours.optional} key="optional"/>);
    }

    const description = (data.description || data.filterName);

    listItemProps.secondaryText = (
            <Link to={infoLink} className="secondaryText">
                <em>{description}</em><br/>
                {iconGroup}
            </Link>
    );
    listItemProps.secondaryTextLines = 2;

    return (
        <ListItem
            {...listItemProps}
            leftAvatar={
                <Link to={infoLink}>
                    <AssignmentIcon style={style.icon} color={statusColours.primary}/>
                </Link>
            }
            rightIcon={<ContextIconMenu actions={getActions(data, actions)} data={data}/>}
        />
    );
};

AssignmentListItem.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        filterName: PropTypes.string,
        programmeName: PropTypes.string,
    }).isRequired,
    actions: PropTypes.shape({
        assignDialogAction: PropTypes.func.isRequired,
    })
};

AssignmentListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};
export default AssignmentListItem;

